import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('applicationActivityList');

    return {
        ACRES: t('acres'),
        ACTIVITY: t('activity'),
        APPLICATION_COMPLETE: t('applicationComplete'),
        APPLICATION_STARTED: t('applicationStarted'),
        DURATION: t('duration'),
        FLIGHT: t('flight'),
        GALLONS: t('gallons'),
        MINUTES: t('minutes'),
        NO_ACTIVITY: t('noActivity')
    };
};

export default useTranslation;
